import { DeleteUserPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useDeleteRoleUserMutation } from 'modules/roles-manager/store';
import { useUsersPagesCache } from 'modules/roles-manager/ui/hooks/use-roles-manager-provider';
import { useCallback } from 'react';

/** Удалить пользователя организации; кэш страниц обновляет сам endpoint, счётчик страниц сбрасывается здесь. */
export function useDeleteUser(tournamentId?: number) {
  const [trigger, { isLoading }] = useDeleteRoleUserMutation();
  const { resetPagesCache } = useUsersPagesCache();

  const deleteUser = useCallback(
    async (payload: DeleteUserPayload) => {
      if (!tournamentId) throw new Error('No tournamentId');
      const deleted = await trigger({ organizerId: tournamentId, payload }).unwrap();
      resetPagesCache();
      return deleted;
    },
    [resetPagesCache, tournamentId, trigger],
  );

  return { deleteUser, isLoading };
}

export default useDeleteUser;
